import axiosInstance from "../config/axiosConfig";

const AcademicLevelService = {
  getAcademicLevels: async ({ signal } = {}) => {
    try {
      const response = await axiosInstance.get("/academic-levels", { signal });
      return { success: true, data: response.data };
    } catch (error) {
      if (error.code !== "ERR_CANCELED") console.error("Error fetching academic levels:", error.response?.data);
      return { success: false, error: error.response?.data };
    }
  },

  getAcademicStages: async ({ signal } = {}) => {
    try {
      const response = await axiosInstance.get("/academic-stages", { signal });
      return { success: true, data: response.data };
    } catch (error) {
      if (error.code !== "ERR_CANCELED") console.error("Error fetching academic stages:", error.response?.data);
      return { success: false, error: error.response?.data };
    }
  },

  getAcademicLevelsByStage: async (stageId, { signal } = {}) => {
    try {
      const response = await axiosInstance.get(`/academic-stages/${encodeURIComponent(stageId)}/levels`, { signal });
      return { success: true, data: response.data };
    } catch (error) {
      if (error.code !== "ERR_CANCELED") console.error("Error fetching academic levels by stage:", error.response?.data);
      return { success: false, error: error.response?.data };
    }
  },
};

export default AcademicLevelService;
